/*
 * @Author: Ning Tang
 * @LastEditors: Ning Tang
 * @email: Ning.Tang@daocloud.io
 * @gitlab: https://gitlab.daocloud.cn/ning.tang/dso-ui.git
 * @Date: 2023-03-14 16:24:58
 * @LastEditTime: 2023-03-14 16:38:05
 * @motto: Still water run deep
 * @Description: Modify here please
 * @FilePath: \xm\xm-runing-main\src\events\eventBus.ts
 */
import mitt from '@/utils/mitt'

const emitter = mitt()
export default emitter;
